export enum CellType {
  FREE = "free",
  CROP = "crop",
  OUT = "out",
  PATH = "path",
  OBSTACLE = "obstacle",
  WATER = "water",
  GRASS = "grass",
  BUILDING = "building",
  TREE = "tree",
  HEDGE = "hedge",
}
